import { createSelector } from '@reduxjs/toolkit';
import { equalsIgnoreCase } from 'src/utils/stringUtils';
// TODO: data скорее всего будет разнесена, когда структура данных станет более понятна
export const getData = (state) => state.get('data');
const _getCitizenships = (state) => getData(state).get('citizenships');
export const getCitizenships = createSelector(
  [_getCitizenships],
  (citizenships): { value: number; label: string }[] =>
    citizenships
      ? citizenships.map(([label, value]) => ({ value, label })).toJS()
      : [],
);

const _getValidatedTourists = (state) =>
  getData(state).get('validatedTourists');
export const getIsTouristValidated = (state, index) => {
  const validatedTourists = _getValidatedTourists(state);
  return validatedTourists && validatedTourists.contains(index);
};
export const getIsTouristValidatedCount = createSelector(
  _getValidatedTourists,
  (validatedTourists) => {
    const formattedValidatedTourists =
      validatedTourists && validatedTourists.toJS();
    return formattedValidatedTourists.length;
  },
);

export const makeGetIsTouristValidated = () => getIsTouristValidated;
export const _getMockTourists = (state) => getData(state).get('mockTourists');
export const getMockTourists = createSelector(
  _getMockTourists,
  (data) => data && data.toJS(),
);

const _getSavedTourists = (state) => getData(state).get('tourists');
export const getSavedTourists = createSelector(
  _getSavedTourists,
  (tourists) => tourists && tourists.toJS(),
);

export const getSavedTouristsByDocType = createSelector(
  [getSavedTourists, (_, docType) => docType],
  (savedTourists, docType) =>
    savedTourists?.filter((tourist) =>
      equalsIgnoreCase(docType, tourist.docType),
    ),
);

const _getIsResetDefaultClientData = (state) =>
  getData(state).get('resetDefaultClientData');
export const getIsResetDefaultClientData = createSelector(
  _getIsResetDefaultClientData,
  (isResetDefaultClientData): boolean => Boolean(isResetDefaultClientData),
);
